// src/components/common/ErrorBoundary.jsx
import React from 'react';
import { ErrorRecovery } from './ErrorRecovery';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ errorInfo });
        
        // Enhanced error logging
        console.error('ErrorBoundary caught an error:', {
            error: error.message,
            stack: error.stack,
            componentStack: errorInfo.componentStack,
            timestamp: new Date().toISOString(),
            url: window.location.href,
        });

        // Report to error tracking service (if available)
        if (window.gtag) {
            window.gtag('event', 'exception', {
                description: error.message,
                fatal: true,
            });
        }
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
        
        // Call parent reset handler if provided
        if (this.props.onReset) {
            this.props.onReset();
        }
    };

    render() {
        if (this.state.hasError) {
            // Use custom fallback if provided
            if (this.props.fallback) {
                return this.props.fallback;
            }

            // Use enhanced ErrorRecovery component
            return (
                <ErrorRecovery
                    error={this.state.error}
                    resetError={this.handleReset}
                    title={this.props.title}
                    showTechnicalDetails={this.props.showDetails || false}
                    customActions={this.props.customActions}
                />
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;